export { mapPayloadTo, createRequestActions, createRequestTypes } from 'settings-ui-lib/utils/actions';
export function createAction(type, payload = {}) {
  return {
    type,
    payload
  };
}